import moment from 'moment';

export default function (timestamp: number | string, dateFormat = 'MM/DD/YYYY HH:mm'): string {
  if (timestamp) {
    return moment(timestamp).utc().format(dateFormat);
  }
}
